var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M14.6667 14.1667H14V6.65335C14 6.24002 13.8133 5.85335 13.4867 5.60002L12.6667 4.96002L12.6533 3.32669C12.6533 2.96002 12.3533 2.66669 11.9867 2.66669H9.71333L8.81999 1.97335C8.33999 1.59335 7.66 1.59335 7.18 1.97335L2.51333 5.60002C2.18666 5.85335 1.99999 6.24002 1.99999 6.64669L1.96666 14.1667H1.33333C1.05999 14.1667 0.833328 14.3934 0.833328 14.6667C0.833328 14.94 1.05999 15.1667 1.33333 15.1667H14.6667C14.94 15.1667 15.1667 14.94 15.1667 14.6667C15.1667 14.3934 14.94 14.1667 14.6667 14.1667ZM4.33333 8.50002V7.50002C4.33333 7.13335 4.63333 6.83335 5 6.83335H6.33333C6.7 6.83335 7 7.13335 7 7.50002V8.50002C7 8.86669 6.7 9.16669 6.33333 9.16669H5C4.63333 9.16669 4.33333 8.86669 4.33333 8.50002ZM9.66666 14.1667H6.33333V12.3334C6.33333 11.78 6.77999 11.3334 7.33333 11.3334H8.66666C9.22 11.3334 9.66666 11.78 9.66666 12.3334V14.1667ZM11.6667 8.50002C11.6667 8.86669 11.3667 9.16669 11 9.16669H9.66666C9.3 9.16669 9 8.86669 9 8.50002V7.50002C9 7.13335 9.3 6.83335 9.66666 6.83335H11C11.3667 6.83335 11.6667 7.13335 11.6667 7.50002V8.50002Z",
          fill: _vm.color
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }